import React, { Children, useContext, useEffect, useRef, useState } from "react";
import { Table } from "react-super-responsive-table";
import { useNavigate } from "react-router-dom";
import DetailPageModal from "./DetailPage/DetailPageModal";
import { ThreeBounce } from "better-react-spinkit";
import "./style.css";
import {
  CardBody,
  CardTitle,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
  Label,
  InputGroup,
  Alert
} from "reactstrap";
import { AddButton, Breadcrumb, Filter, ToggleSelector, DateRange } from "../../components";
import SelectButton from "../Buttons/Icons/SelectButton";
import AddNewButton from "../Buttons/AddNewButton";
import { I18nContext } from "../../store/context/i18nContext";
import { normalizeTestIdSegment, resolveAutomationTestId } from "../InputField/testId";
import { DatePicker, Space } from 'antd';
import dayjs from 'dayjs';
import moment from "moment";
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const { RangePicker } = DatePicker;

const dateFormat = 'YYYY-MM-DD';


const Layout = ({
  compact,
  children,
  insidePane,
  headingCentre,
  classNameForDetailPage,
  styleDetailPageContainer,
  backDetailPage,
  showDetailPage,
  small,
  medium,
  large,
  layoutForm,
  hideTitleBar,
  title,
  tableCardClass = "",
  customTitleComponent = () => <></>,
  filterStructure,
  filterValues,
  onApplyFilter,
  hideSearch,
  hideAdd,
  onAddClick,
  onAddNewClick,
  onSelectClick,
  customOnAddClick,
  gridLoading,
  showToggle,
  toggleData,
  showDateRange,
  onToggle,
  clientValue,
  onChangeClient,
  leftChildComponent,
  setData,
  data = [],
  fromDate,
  tillDate,
  setTillDate,
  setFromDate,
  breadcrumb,
  headerActions,
  topBarContent = null,
  navigateOnFilter = true,
  defaultFilters = [],
  detailSidebar,
  testId,
}) => {
  let _actionMenu,
    _theadFull,
    _onAlert,
    _tbodyFull,
    _table,
    _detailPageTitle,
    _detailPageBody,
    _detailPageFooter,
    _leftChild;

  const { t } = useContext(I18nContext);
  let navigate = useNavigate();
  const [actionMenuOpen, setActionMenuOpen] = useState(false);
  const actionMenuRef = useRef(null);
  const routeSegment = typeof window !== "undefined" ? window.location.pathname.split("/")[1] : "";
  const titleSegment = typeof title === "string" ? title : "";
  const layoutTestId = resolveAutomationTestId(
    testId,
    `section-${normalizeTestIdSegment(titleSegment || routeSegment || "layout")}`
  );



  Children.forEach(children, (child) => {
    if (child.type === Layout?.ActionMenu) {
      return (_actionMenu = child);
    }
    if (child.type === Layout?.TheadFull) {
      return (_theadFull = child);
    }
    if (child.type === Layout?.TbodyFull) {
      return (_tbodyFull = child);
    }
    if (child.type === Layout?.Table) {
      return (_table = child);
    }
    if (child.type === Layout?.DetailPageTitle) {
      return (_detailPageTitle = child);
    }
    if (child.type === Layout?.DetailPageBody) {
      return (_detailPageBody = child);
    }
    if (child.type === Layout?.DetailPageFooter) {
      return (_detailPageFooter = child);
    }
    if (child.type === Layout?.OnAlert) {
      return (_onAlert = child);
    }
    if (child.type === Layout?.LeftChild) {
      return (_leftChild = child);
    }


  });
  const actionMenuNode = _actionMenu?.props?.children;
  const normalizeActionMenuNode = (node) => {
    if (node?.type === DropdownMenu) {
      return {
        className: node?.props?.className || "",
        content: node?.props?.children,
      };
    }

    const dropdownChildren = React.Children.toArray(node?.props?.children)
      .filter((child) => React.isValidElement(child) && child.type === DropdownMenu);

    if (dropdownChildren.length) {
      return {
        className: [node?.props?.className, dropdownChildren[0]?.props?.className]
          .filter(Boolean)
          .join(" "),
        content: dropdownChildren.flatMap((child) => React.Children.toArray(child?.props?.children)),
      };
    }

    return {
      className: "",
      content: node,
    };
  };
  const normalizedActionMenu = normalizeActionMenuNode(actionMenuNode);
  const actionMenuClassName = normalizedActionMenu.className;
  const actionMenuContent = normalizedActionMenu.content;

  const getActionMenuItemTestId = (child, index) => {
    const actionKey = child.props?.action || child.props?.id || (typeof child.props?.children === "string" ? child.props.children : index);
    return child.props?.["data-testid"] || child.props?.testId || `${layoutTestId}-action-${normalizeTestIdSegment(actionKey)}`;
  };

  const renderActionMenuContent = (content) =>
    React.Children.map(content, (child, index) => {
      if (!React.isValidElement(child)) return child;
      if (child.type === React.Fragment) {
        return renderActionMenuContent(child.props?.children);
      }
      if (child.type === DropdownItem) {
        if (child.props?.divider) {
          return <div className="layout-action-menu__divider" data-testid={`${layoutTestId}-action-divider-${index}`} />;
        }
        if (child.props?.header) {
          return (
            <div className={`layout-action-menu__header ${child.props?.className || ""}`.trim()} data-testid={`${layoutTestId}-action-header-${index}`}>
              {child.props?.children}
            </div>
          );
        }
        return (
          <button
            type="button"
            className={`layout-action-menu__item ${child.props?.className || ""}`.trim()}
            onClick={child.props?.onClick}
            disabled={child.props?.disabled}
            data-testid={getActionMenuItemTestId(child, index)}
          >
            {child.props?.children}
          </button>
        );
      }
      return child;
    });

  useEffect(() => {
    if (!actionMenuOpen) return undefined;
    const handleClickOutside = (event) => {
      if (!actionMenuRef.current) return;
      if (!actionMenuRef.current.contains(event.target)) {
        setActionMenuOpen(false);
      }
    };
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setActionMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [actionMenuOpen]);

  return (
    <React.Fragment>
      <div className={` ${insidePane ? " p-0 m-0 " : " "}`} style={{ backgroundColor: "#fff" }} data-testid={layoutTestId}>
        {topBarContent}
        {headingCentre}

        <DetailPageModal
          classNameForDetailPage={classNameForDetailPage}
          insidePane={insidePane}
          style={styleDetailPageContainer}
          back={backDetailPage}
          _body={_detailPageBody}
          _title={_detailPageTitle}
          _footer={_detailPageFooter}
          show={showDetailPage}
          small={small}
          medium={medium}
          large={large}
          detailSidebar={detailSidebar}
          testId={`${layoutTestId}-detail`}
        />
        <Row className="m-0 p-0">
          <Col className={"left-scroll-independent col-md-12"} style={{ height: insidePane ? "calc(100% )" : "calc(100vh - 120px)" }}>
            {_onAlert && (
              <UncontrolledDropdown className="mt-3">
                {_onAlert}
              </UncontrolledDropdown>
            )}
            <div className={`${!insidePane ? "card" : ""} mx-0 pt-1`} style={{ height: layoutForm ? `97%` : "" }}>
              {!hideTitleBar && (
                <CardTitle className="pt-3 ps-4 pe-3 pb-0" data-testid={`${layoutTestId}-title-bar`}>
                  <div className={`d-flex justify-content-between flex-sm-row col-12 flex-column-reverse align-items-sm-center mt-3 mt-sm-0
 mb-0`}>
                    <div className="d-flex flex-row gap-3">
                      {/* {title && <Breadcrumb title={title} />} */}
                      {breadcrumb && <Breadcrumb title={breadcrumb} />}
                      {customTitleComponent()}
                      {showToggle &&
                        <>
                          {filterStructure && (
                            <ToggleSelector
                              style={{
                                fontSize: '12px',
                                // minWidth: '300px',
                                maxWidth: '100%',
                                display: 'flex',
                                flexWrap: 'wrap',
                                width: compact ? 'max-content' : `calc(${toggleData?.module?.length * 135}px)`
                              }}
                              compact
                              data={toggleData?.module}
                              value={toggleData?.toggleValue}
                              onChange={(selectedValue) => { onToggle(selectedValue) }}
                            />

                          )}
                        </>
                      }
                      {showDateRange &&
                        <div className="mt-3">
                          <DateRange
                            defaultValue={[null, null]}
                            disabled={[false, false]}
                            onChange={(dates) => {
                              if (dates === null) {
                                setFromDate(null);
                                setTillDate(null);
                              } else {
                                const formattedFromDate = moment.unix(dates[0]).format('YYYYMMDD');
                                const formattedTillDate = moment.unix(dates[1]).format('YYYYMMDD');
                                setFromDate(formattedFromDate);
                                setTillDate(formattedTillDate);
                              }
                            }
                            }
                          />
                        </div>
                      }
                      {/* {showClientSelect && (
                        <ClientSelect
                          value={clientValue}
                          onChange={(v) => onChangeClient(v)}
                          className="col-sm-8"
                          style={{ marginLeft: '40px', zIndex: '4' }}
                        />
                      )} */}
                    </div>
                    <div className="d-flex ">
                      {!hideSearch &&
                        <div className="flex-1">
                          {filterStructure && (
                            <Filter
                              isRate={showToggle}
                              className="mb-2 ms-3 "
                              value={filterValues}
                              structure={filterStructure}
                              applyFunc={onApplyFilter}
                              insidePane={insidePane}
                              navigateOnFilter={navigateOnFilter}
                              defaultFilters={defaultFilters}
                              testId={`${layoutTestId}-filters`}
                            />
                          )}
                        </div>
                      }
                      {headerActions ? (
                        <div className="d-flex align-items-center mb-2 ms-2">
                          {headerActions}
                        </div>
                      ) : null}
                      <div className="d-flex mb-2">
                        {!hideAdd &&
                          <div>
                            {onAddClick && (
                              <AddButton
                                testId={`${layoutTestId}-add`}
                                onClick={() => {
                                  onAddClick();
                                }}
                              />
                            )}
                          </div>
                        }
                        {onAddNewClick && (
                          <AddNewButton
                            testId={`${layoutTestId}-add-new`}
                            onClick={() => {
                              onAddNewClick();
                            }}
                          />
                        )}
                        {onSelectClick && (
                          <SelectButton
                            testId={`${layoutTestId}-select`}
                            onClick={() => {
                              onSelectClick();
                            }}
                          />
                        )}
                        {/* For Template Action Menu */}
                        {customOnAddClick && (
                          <UncontrolledDropdown className="ms-2">
                            <DropdownToggle
                              data-testid={`${layoutTestId}-custom-add-toggle`}
                              style={{ padding: "0", color: "transparent" }}
                            >
                              <AddButton
                                onClick={() => { }}
                                className={"btn btn-primary"}
                                testId={`${layoutTestId}-custom-add`}
                              />
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-end" data-testid={`${layoutTestId}-custom-add-menu`}>
                              <DropdownItem header data-testid={`${layoutTestId}-custom-add-header`}>Create Template</DropdownItem>
                              <DropdownItem
                                data-testid={`${layoutTestId}-custom-add-upload`}
                                onClick={() => {
                                  customOnAddClick(true);
                                }}
                              >
                                For Upload
                              </DropdownItem>
                              <DropdownItem
                                data-testid={`${layoutTestId}-custom-add-download`}
                                onClick={() => {
                                  customOnAddClick(false);
                                }}
                              >
                                For Download
                              </DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        )}
                        {_actionMenu && (
                          <div className="layout-action-menu__dropdown ms-2" ref={actionMenuRef} data-testid={`${layoutTestId}-action-menu`}>
                            <button
                              type="button"
                              className={`layout-action-menu__toggle ${actionMenuOpen ? "is-open" : ""}`}
                              onClick={() => setActionMenuOpen((prev) => !prev)}
                              aria-haspopup="menu"
                              aria-expanded={actionMenuOpen}
                              aria-label="Actions"
                              title="Actions"
                              data-testid={`${layoutTestId}-action-menu-toggle`}
                            >
                              <i className="bx bx-dots-horizontal-rounded" />
                            </button>
                            {actionMenuOpen ? (
                              <div
                                className={`layout-action-menu layout-action-menu__panel dropdown-menu show ${actionMenuClassName || ""}`.trim()}
                                role="menu"
                                onClick={() => setActionMenuOpen(false)}
                                data-testid={`${layoutTestId}-action-menu-panel`}
                              >
                                {renderActionMenuContent(actionMenuContent)}
                              </div>
                            ) : null}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </CardTitle>
              )}
              <CardBody style={{ height: "100%" }} className={tableCardClass}>
                {gridLoading ? (
                  <div className="d-flex align-items-center justify-content-center">
                    <ThreeBounce size={20} color="pink" />
                  </div>
                ) : (
                  <>
                    <div className="d-md-flex flex-1">
                      {_leftChild}
                      {/* <div className="d-flex flex-1"> */}
                      <div
                        // className="table-rep-plugin table-responsive mb-0"
                        data-pattern="priority-columns"
                        data-testid={`${layoutTestId}-table`}
                        style={{
                          height: layoutForm ? `calc(100vh - 230px)` : "",
                          width: '100%',
                        }}
                      >

                        {_table}
                        <Table className="table mb-2 striped-table">
                          {_theadFull}
                          {_tbodyFull}
                        </Table>
                      </div>
                      {/* </div> */}
                    </div>
                  </>
                )}
              </CardBody>
            </div>
          </Col>
        </Row>
      </div>
    </React.Fragment >
  );
};

Layout.ActionMenu = ({ children }) => <> {children} </>;
Layout.TheadFull = ({ children }) => <> {children} </>;
Layout.TbodyFull = ({ children }) => <> {children} </>;
Layout.Table = ({ children }) => <> {children} </>;
Layout.DetailPageTitle = ({ children }) => <h5 className="mb-0 w-100" style={{ fontSize: 12, fontWeight: "500", paddingLeft: "5px" }}> {children} </h5>;
Layout.DetailPageBody = ({ children }) => <> {children} </>;
Layout.DetailPageFooter = ({ children }) => <div className=" d-flex justify-content-end"> {children} </div>;
Layout.OnAlert = ({ children }) => <> {children} </>;
Layout.LeftChild = ({ children }) => <> {children} </>;


export default Layout;
